import { createRequest, } from '~/utils/api'
import appendQuery from 'append-query'
import queryString from 'query-string'

export const validateToken = ({ token, }) =>
  createRequest(
    {
      method: 'GET',
      url: appendQuery(
        '/autocomplete/place',
        queryString.stringify({
          name: 'paris',
        }),
      ),
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    ['Paris area', 'Los Angeles area, CA', 'Cleveland area, NY',],
  )
